import React, { useEffect, useState } from 'react';
import { Form, Input, Button, InputNumber, Select, Row, Col, Card, DatePicker } from 'antd';
import { ServicetypeService } from '../../../Services/Manage/ServicetypeService';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import { Dropdown, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";


dayjs.extend(weekday);
dayjs.extend(localeData);

const { TextArea } = Input;

const SourceDropdown = ({ value, onChange }) => {
  const [selected, setSelected] = useState(value || "");
  const [open, setOpen] = useState(false);
  const [customInput, setCustomInput] = useState(value || "");

  const items = [
    { key: "Telecalling", label: "Telecalling" },
    { key: "Reference", label: "Reference" },
    { key: "Walk-in", label: "Walk-in" },
  ];

  const handleMenuClick = ({ key }) => {
    setSelected(key);
    setCustomInput(key);
    onChange?.(key);
    setOpen(false);
  };

  const handleCustomInput = (e) => {
    const val = e.target.value;
    setCustomInput(val);
    setSelected(val);
    onChange?.(val);
  };

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      menu={{
        items,
        onClick: handleMenuClick,
        selectable: true,
        selectedKeys: [selected],
      }}
    >
      <Space style={{ width: "100%" }}>
        <Input
          size="large"
          placeholder="Select or type source"
          value={customInput}
          onChange={handleCustomInput}
          suffix={<DownOutlined onClick={() => setOpen(!open)} />}
        />
      </Space>
    </Dropdown>
  );
};


const CreateEnquiry = ({ initialValues, onSubmit, onCancel, handleEQNo }) => {
  const [form] = Form.useForm();
  const [enquiryNo, setEnquiryNo] = useState('');
  const [optionService, setOptionService] = useState([]);
  const [optionServiceType, setOptionServiceType] = useState([]);
  const [optionStatus, setOptionStatus] = useState([]);
  const [optionCrncy, setCrncy] = useState([]);

  const getAllServices = async () => {
    try {
      const request = await ServicetypeService.getAllServices();
      setOptionService(
        request.data.map((item, index) => ({
          value: item.id,
          label: item.service_name
        }))
      );

    } catch (error) {
      console.error(error);
    }
  };

  const onChange = (date, dateString) => {
    console.log(date, dateString);
  }

  const getAllServicetype = async () => {
    try {
      const request = await ServicetypeService.getAllServicesType();
      setOptionServiceType(
        request.data.map((item, index) => ({
          value: item.id,
          label: item.type_name
        }))
      );

    } catch (error) {
      console.error(error);

    }
  };

  const getAllStatus = async () => {
    try {
      const request = await ServicetypeService.getAllStatus();
      setOptionStatus(
        request.data.map((item, index) => ({
          value: item.name,
          label: item.name
        }))
      );

    } catch (error) {
      console.error(error);

    }
  };

  const getAllCurrency = async () => {
    try {
      const request = await ServicetypeService.getAllCurrency();
      setCrncy(
        request.data.map((item, index) => ({
          value: item.code,
          label: `${item.code}- ${item.name}`
        }))
      );

    } catch (error) {
      console.error(error);

    }
  };


  useEffect(() => {
    getAllServices();
    getAllServicetype();
    getAllStatus();
    getAllCurrency();
  }, [])

  useEffect(() => {
    if (!initialValues?.eq_no) {
      generateEnquiryNo();
    } else {
      setEnquiryNo(initialValues.eq_no);
    }
  }, [initialValues]);

  const generateEnquiryNo = () => {
    const now = new Date();
    const day = now.getDate().toString().padStart(2, '0');
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const random4Digit = Math.floor(1000 + Math.random() * 9000);
    const seconds = now.getSeconds().toString().padStart(2, '0');
    const milliseconds = now.getMilliseconds().toString().padStart(3, '0').slice(0, 2);
    const timeDigits = seconds + milliseconds;
    const newEnquiryNo = `${day}${month}-${random4Digit}-${timeDigits}`;
    setEnquiryNo(newEnquiryNo);
    handleEQNo(newEnquiryNo);
    form.setFieldsValue({ eq_no: newEnquiryNo });
  };

  const handleFinish = async (values) => {
    try {

      const formattedFollowUp = values.n_follow_up
        ? dayjs(values.n_follow_up).format("YYYY-MM-DD")
        : null;

      const finalData = {
        ...values,
        n_follow_up: formattedFollowUp,
        eq_no: enquiryNo,
      };

      console.log("📦 Enquiry Data Submitted:", finalData);

      onSubmit(finalData);
      form.resetFields();
    } catch (error) {
      console.error("❌ Enquiry operation failed:", error);
    }
  };


  return (
    <Form form={form} layout="vertical" initialValues={initialValues || {}} onFinish={handleFinish}>
      {/* Row 1: Enquiry Basics */}
      <Card title="Enquiry Details" style={{ marginBottom: 24 }}>
        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item name="service_id" label="Service">
              <Select
                options={optionService}
                size="large"
                showSearch
                allowClear
                placeholder="Select a service"
                filterOption={(input, option) =>
                  (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="eq_source"
              label="Source"
              rules={[{ required: true, message: 'Please select or type a source' }]}
            >
              <SourceDropdown />
            </Form.Item>

          </Col>


          <Col xs={24} sm={8}>
            <Form.Item name="eq_description" label="Description">
              <TextArea rows={2} size="large" maxLength={50} />
            </Form.Item>
          </Col>

        </Row>
      </Card>

      {/* Row 2: Financial & Type Details */}
      <Card title="Service & Financial Details" style={{ marginBottom: 24 }}>
        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item name="service_type_id" label="Service Type">
              <Select options={optionServiceType} size="large"
                showSearch
                allowClear
                placeholder="Select a service Type" // optional placeholder
                filterOption={(input, option) =>
                  (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                } />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name="total_amount" label="Total Amount">
              <InputNumber allowClear size="large" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name="currency" label="Currency">
              <Select size="large" placeholder="Select currency" allowClear options={optionCrncy}
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                }
              />

            </Form.Item>
          </Col>
        </Row>
      </Card>

      {/* Row 3: Customer Details */}
      <Card title="Customer Details">
        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item name="name" label="Customer Name">
              <Input size="large" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name="mobile_no" label="Mobile No">
              <InputNumber allowClear size="large" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name="address" label="Address">
              <TextArea rows={2} size="large" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item name="eq_status" label="Enquiry Status">
              <Select
                options={optionStatus}
                size="large"
                showSearch
                allowClear
                placeholder="Select a status"
                filterOption={(input, option) =>
                  (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>


          <Col xs={24} sm={8}>
            <Form.Item name="n_follow_up" label="Next Follow-up On">
              <DatePicker
                size='large'
                defaultValue={dayjs()}
                format="DD-MM-YYYY"
                onChange={(date) => form.setFieldsValue({ n_follow_up: date })}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item name="note" label="Note/ Comment">
              <TextArea rows={2} size="large" />
            </Form.Item>
          </Col>

        </Row>
      </Card>

      {/* Buttons */}
      <div style={{ textAlign: 'right', marginTop: 24 }}>
        <Button onClick={onCancel} style={{ marginRight: 8 }} size="large">Cancel</Button>
        <Button type="primary" htmlType="submit" size="large">
          {initialValues?.id ? 'Update' : 'Create'}
        </Button>
      </div>
    </Form>
  );
};

export default CreateEnquiry;